import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { format } from 'date-fns';
import Table from '../../components/table/Table';
import TableWrapper from '../components/table-wrapper/TableWrapper';
import TBody from '../../components/table/TBody/TBody';
import THead from '../../components/table/THead/THead';
import TR from '../../components/table/TR/TR';
import TH from '../../components/table/TH/TH';
import TD from '../../components/table/TD/TD';
import Button from '../../components/form/button/Button';
import { RootState } from '../../core/state/state';
import { getNotifications } from '../../core/state/notifications/asyncActions';
import Image from '../../components/image/Image';
import { DATE_FORMAT_EU_DOT, DATE_FORMAT_HOURS_MINUTES } from '../../core/constants/date';
import ManageNotifications from './manage-notifications/ManageNotifications';
import { BASE_URL } from '../../core/constants/api';
import Avatar from '../components/avatar/Avatar';

import './Notifications.scss';

interface Props {
  pageType: number;
}

const Notifications: React.FC<Props> = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const notifications = useSelector((state: RootState) => state.notifications.notifications);
  const [isOpen, setIsOpen] = useState(false);

  React.useEffect(() => {
    dispatch(getNotifications(true));
  }, [dispatch]);

  return (
    <div className="notifications">
      <TableWrapper
        header={
          <div className="d-flex w-100 justify-content-between">
            <div>{t('notification.title')}</div>
            <div>
              <Button onClick={() => setIsOpen(true)} buttonTypes={['blue-outline']}>
                {t('notification.manageNotifications')}
              </Button>
            </div>
          </div>
        }
        content={
          <>
            <Table>
              <THead>
                <TR>
                  <TH>{t('notification.projectName')}</TH>
                  <TH>{t('common.action')}</TH>
                  <TH>{t('common.date')}</TH>
                  <TH>{t('common.time')}</TH>
                  <TH>{t('common.by')}</TH>
                </TR>
              </THead>
              <TBody>
                {notifications?.map((notification) => {
                  const date = new Date(notification.createdOn);
                  return (
                    <TR key={notification.id}>
                      <TD>
                        <div className="d-flex align-items-center ">
                          <Avatar>
                            <Image src={`${BASE_URL}/${notification.photo}`} alt="image" />
                          </Avatar>
                          <span className="notifications__name">{notification.projectName}</span>
                        </div>
                      </TD>
                      <TD>{t(`notification.bookingType.${notification.notificationTypeID}`)}</TD>
                      <TD>{format(date, DATE_FORMAT_EU_DOT)}</TD>
                      <TD>{format(new Date(`${date}Z`), DATE_FORMAT_HOURS_MINUTES)}</TD>
                      <TD>
                        <span className="notifications__name">{notification.createdBy}</span>
                      </TD>
                    </TR>
                  );
                })}
              </TBody>
            </Table>
          </>
        }
      />
      <ManageNotifications isOpen={isOpen} setIsOpen={setIsOpen} />
    </div>
  );
};

export default Notifications;
